import { api } from 'bxcommon/store/api';
import { hydrateList } from 'bxcommon/store/slices/list.slice';
import { setUserGroup } from '../slices/selectedUserGroup.slice';

const prospectusApi = api.injectEndpoints({
  endpoints: (build) => ({
    getProspectusList: build.query({
      query: ({ search, query } = {}) => {
        const params = search ? `?${query}=${search}` : '';
        return { url: `/prospectuses/${params}` };
      },
      transformResponse: (response) => response.data,
      providesTags: ['List'],
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          dispatch(hydrateList(data));
        } catch {
          // handled by interceptor
        }
      },
    }),

    deleteProspectus: build.mutation({
      query: (caseId) => ({ url: `/prospectuses/${caseId}/`, method: 'DELETE' }),
      invalidatesTags: ['List'],
    }),

    getUserGroups: build.query({
      query: () => ({ url: '/groups/' }),
      transformResponse: (response) => response.data,
      providesTags: ['UserGroups'],
    }),

    deleteUserGroup: build.mutation({
      query: (id) => ({ url: `/groups/${id}/`, method: 'DELETE' }),
      onQueryStarted: async (id, { dispatch, queryFulfilled }) => {
        const patch = dispatch(
          prospectusApi.util.updateQueryData('getUserGroups', undefined, (draft) =>
            draft.filter((group) => group.id !== id)
          )
        );
        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },
      invalidatesTags: ['UserGroups'],
    }),

    addUserGroup: build.mutation({
      query: (payload) => ({ url: '/groups/', method: 'POST', data: payload }),
      transformResponse: (response) => response.data,
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;
        dispatch(setUserGroup(data));
      },
      invalidatesTags: ['UserGroups'],
    }),

    updateUserGroup: build.mutation({
      query: ({ data, id }) => ({ url: `/groups/${id}/`, method: 'PUT', data }),
      transformResponse: (response) => response.data,
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;
        dispatch(setUserGroup(data));
      },
      invalidatesTags: ['UserGroups'],
    }),
  }),
});

export const {
  useGetProspectusListQuery,
  useLazyGetProspectusListQuery,
  useDeleteProspectusMutation,
  useGetUserGroupsQuery,
  useDeleteUserGroupMutation,
  useAddUserGroupMutation,
  useUpdateUserGroupMutation,
} = prospectusApi;
